import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';
import { HttpClient } from '@angular/common/http';
import { NgForm } from '@angular/forms';

interface CommitteeMember {
  slno: number;
  name: string;
  position: string;
  category: string;
  occupation: string;
}

interface SquadMember {
  slno: number;
  name: string;
  designation: string;
  post: string;
  contact: string;
}

@Component({
  selector: 'app-my-dashboard-page',
  templateUrl: './my-dashboard-page.component.html',
  styleUrls: ['./my-dashboard-page.component.scss']
})
export class MyDashboardPageComponent implements OnInit {
  isToggled = false;

  formData = {
    name: '',
    department: '',
    gender: '',
    year_of_study: '',
    complaint_summary: '',
    incident_date: '',
    description: '',
    declaration_confirmed: false
  };

  submitting = false;
  submitSuccess = false;
  submitError = false;
  submitMessage = '';

  readonly API = 'https://fmcet.ac.in/backend/anti_ragging/addComplaint.php';

  committeeMembers: CommitteeMember[] = [
    { slno: 1,  name: 'Dr.P.Nelson Raja',        position: 'Chairman', category: 'Principal',               occupation: 'Principal' },
    { slno: 2,  name: 'Mr.V.Saravana Ravi',      position: 'Member',   category: 'Police Department',       occupation: 'Police Inspector' },
    { slno: 3,  name: 'Mr.A.Vincent Xavier Raja', position: 'Member',  category: 'Revenue Department',      occupation: 'Officer' },
    { slno: 4,  name: 'Ms.V.Joseph Mary',        position: 'Member',   category: 'Official of NGO',         occupation: 'Officer' },
    { slno: 5,  name: 'Dr.R.Natarajan',          position: 'Member',   category: 'Faculty Member',          occupation: 'Professor' },
    { slno: 6,  name: 'Dr.P.Ravikumaran',        position: 'Member',   category: 'Faculty Member',          occupation: 'Professor' },
    { slno: 7,  name: 'Mr.A.Athimoolam',         position: 'Member',   category: 'Faculty Member',          occupation: 'Associate Professor' },
    { slno: 8,  name: 'Mr.M.Prabakaran',         position: 'Member',   category: 'Faculty Member',          occupation: 'Associate Professor' },
    { slno: 9,  name: 'Ms.M.Aishwarya',          position: 'Member',   category: 'Faculty Member',          occupation: 'Assistant Professor' },
    { slno: 10, name: 'Mr.S.Anatharajan',        position: 'Member',   category: 'Parent Representative',   occupation: 'Business' },
    { slno: 11, name: 'Mr.A.D.gowthaman',        position: 'Member',   category: 'Student Representative',  occupation: 'Student' },
    { slno: 12, name: 'Mr.B.Velayutham',         position: 'Member',   category: 'Student Representative',  occupation: 'Student' },
    { slno: 13, name: 'Mr.T.M.Sivasankar',       position: 'Member',   category: 'Non-Teaching Staff',      occupation: 'Lab Technician' }
  ];

  squadMembers: SquadMember[] = [
    { slno: 1, name: 'Dr. R. Natarajan',      designation: 'HOD/EEE',             post: 'Member', contact: '9655986026' },
    { slno: 2, name: 'Dr. S. Saravana Kumar', designation: 'HOD/Auto',            post: 'Member', contact: '9042796726' },
    { slno: 3, name: 'Dr. S. Ramalingam',     designation: 'Professor/Chemistry', post: 'Member', contact: '9095712737' },
    { slno: 4, name: 'Dr. K. R. Rameela',     designation: 'ASP/EEE',             post: 'Member', contact: '9952239182' },
    { slno: 5, name: 'Ms. K. Aparna Preethi', designation: 'AP/Cyber',            post: 'Member', contact: '9361944507' },
    { slno: 6, name: 'Mr. M. Kathiravan',     designation: 'AP/Mech',             post: 'Member', contact: '9940942608' },
    { slno: 7, name: 'Mr. S. Ganesan',        designation: 'Physical Director',   post: 'Member', contact: '7358816686' },
    { slno: 8, name: 'Ms. M. Iswarya',        designation: 'Lab Technician',      post: 'Member', contact: '9894421810' }
  ];

  constructor(
    public themeService: ThemeCustomizerService,
    private http: HttpClient
  ) {
    this.themeService.isToggled$.subscribe(v => (this.isToggled = v));
  }

  ngOnInit(): void {}

  trackBySlno(index: number, m: { slno: number }): number {
    return m.slno;
  }

  onSubmit(form: NgForm): void {
    if (form.invalid || !this.formData.declaration_confirmed) {
      this.submitError = true;
      this.submitSuccess = false;
      this.submitMessage = 'Please fill all required fields and confirm the declaration.';
      return;
    }

    this.submitting = true;
    this.submitSuccess = false;
    this.submitError = false;
    this.submitMessage = '';

    this.http.post<any>(this.API, this.formData).subscribe({
      next: (res) => {
        this.submitting = false;

        if (res?.status === 'success') {
          this.submitSuccess = true;
          this.submitMessage = res.message || 'Complaint submitted successfully';

          form.resetForm({
            name: '',
            department: '',
            gender: '',
            year_of_study: '',
            complaint_summary: '',
            incident_date: '',
            description: '',
            declaration_confirmed: false
          });
        } else {
          this.submitError = true;
          this.submitMessage = res?.message || 'Submission failed';
        }
      },
      error: (err) => {
        this.submitting = false;
        this.submitError = true;
        this.submitMessage = err?.error?.message || 'Server error. Please try again.';
        console.error('Submit error', err);
      }
    });
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }
}